export default __webpack_public_path__ + "static/media/axs-wei.3b6fc66f.svg";